// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__15oEF","buttons":"PendingPaymentAlert_buttons__1MbW7"};